<div class="below-navbar form">
    <div class="container-xl">
        <div class="group">
            <div class="group-header container">
                <h4>Algemeen</h4>
            </div>
            <div class="group-fields container">
                <div class="algemeen-layout">
                    <!-- Kolom 1: Project info -->
                    <div class="info-col">
                        <div class="info-row">
                            <span class="info-label">Projectnummer</span>
                            <span class="info-value">{{ planning?.afas_project_id || '—' }}</span>
                        </div>
                        <div class="info-row">
                            <span class="info-label">Opdrachtgever</span>
                            <span class="info-value">{{ planning?.contractor || '—' }}</span>
                        </div>
                        <div class="info-row">
                            <span class="info-label">Uitvoerder</span>
                            <span class="info-value">{{ planning?.performer_user?.name || '—' }}</span>
                        </div>
                        <div class="info-row">
                            <span class="info-label">Locatie</span>
                            <span class="info-value">{{ planning?.location || '—' | locationFormat }}</span>
                        </div>
                        <div class="info-row">
                            <span class="info-label">Medewerkers</span>
                            <span class="info-value">
                                @if (medewerkers.length) {
                                    @for (medewerker of medewerkers; track medewerker) {
                                        {{ medewerker }}
                                        @if (!$last) {
                                            ,&nbsp; <br />
                                        }
                                    }
                                } @else {
                                    —
                                }
                            </span>
                        </div>
                    </div>

                    <div class="info-col">
                        <div class="info-row">
                            <span class="info-label">Startdatum</span>
                            <span class="info-value">{{
                                (planning?.mainPlanning?.begindate | date: 'EEEE d MMMM yyyy HH:mm') || '—'
                            }}</span>
                        </div>
                        <div class="info-row">
                            <span class="info-label">Einddatum</span>
                            <span class="info-value">{{
                                (planning?.mainPlanning?.enddate | date: 'EEEE d MMMM yyyy HH:mm') || '—'
                            }}</span>
                        </div>
                        <div class="info-row">
                            <span class="info-label">Status</span>
                            <span class="info-value">
                                <app-field-input [field]="statusField" [hideMatHint]="true" key="status_key" />
                            </span>
                        </div>

                        <div class="info-row">
                            <span class="info-label">Verkeersmaatregel</span>
                            <span class="info-value">{{ planning?.data?.verkeersmaatregel || '—' }}</span>
                        </div>
                        <div class="info-row">
                            <span class="info-label">Materieel</span>
                            <span class="info-value">
                                @if (entities.length) {
                                    @for (r of entities; track r.id) {
                                        {{ r.entity?.name || '—' }} ({{ r.begindate | date: 'HH:mm' }}–{{
                                            r.enddate | date: 'HH:mm'
                                        }})
                                        @if (!$last) {
                                            ,&nbsp; <br />
                                        }
                                    }
                                } @else {
                                    —
                                }
                            </span>
                        </div>
                    </div>
                </div>

                <app-field-input [field]="commentField" [hideMatHint]="true" key="comment" />
            </div>
        </div>

        @if (declarationLocked) {
            <div class="alert alert-warning">
                De verrekening van dit dagrapport is al definitief. De status kan niet meer worden aangepast.
            </div>
        } @else if (readOnly) {
            <div class="alert alert-warning">
                Dit dagrapport is niet meer wijzigbaar in deze status. Wijzig de status om verder te kunnen bewerken.
            </div>
        }

        <form>
            <div class="groups-grid">
                @for (group of groups; track group.key) {
                    <div class="group">
                        <div class="group-header">
                            <h4>{{ group.label }}</h4>
                        </div>

                        <div class="group-fields">
                            @if (group.pairs) {
                                <div class="meting-table">
                                    <div class="meting-header">
                                        <span>Meting 1</span>
                                        <span>Meting 2</span>
                                    </div>
                                    @for (pair of group.pairs; track pair.entry1.key) {
                                        <div class="meting-row">
                                            <div class="autofill-field-wrapper">
                                                <app-field-input
                                                    [key]="pair.entry1.key"
                                                    [field]="pair.entry1.field"
                                                    [hideMatHint]="true" />
                                                @if (autofilledFCs.has(pair.entry1.field.fc)) {
                                                    <button
                                                        class="autofill-edit-btn"
                                                        (click)="unlockFields([pair.entry1.field.fc])"
                                                        type="button"
                                                        title="Overschrijven">
                                                        <i class="far fa-pencil"></i>
                                                    </button>
                                                }
                                            </div>
                                            <div class="autofill-field-wrapper">
                                                <app-field-input
                                                    [key]="pair.entry2.key"
                                                    [field]="pair.entry2.field"
                                                    [hideMatHint]="true" />
                                                @if (autofilledFCs.has(pair.entry2.field.fc)) {
                                                    <button
                                                        class="autofill-edit-btn"
                                                        (click)="unlockFields([pair.entry2.field.fc])"
                                                        type="button"
                                                        title="Overschrijven">
                                                        <i class="far fa-pencil"></i>
                                                    </button>
                                                }
                                            </div>
                                        </div>
                                    }
                                </div>
                            } @else {
                                @for (entry of group.fields; track entry.key) {
                                    <div class="field">
                                        <div class="autofill-field-wrapper">
                                            <app-field-input
                                                [key]="entry.key"
                                                [field]="entry.field"
                                                [hideMatHint]="true" />
                                            @if (autofilledFCs.has(entry.field.fc)) {
                                                <button
                                                    class="autofill-edit-btn"
                                                    (click)="unlockFields([entry.field.fc])"
                                                    type="button"
                                                    title="Overschrijven">
                                                    <i class="far fa-pencil"></i>
                                                </button>
                                            }
                                        </div>
                                    </div>
                                }
                            }
                        </div>
                    </div>
                }
            </div>
        </form>
    </div>
</div>

<app-day-report-buttons
    [navigationDisabled]="saving"
    [showActionButton]="Functionalities.DayreportsMutate | hasFunctionality: user"
    [actionButtonDisabled]="commentControl.invalid"
    [actionButtonText]="saving ? 'Opslaan...' : saved ? 'Opgeslagen' : 'Opslaan'"
    (actionButtonClick)="save()"
    activePage="formulier"
    actionButtonIcon="far fa-floppy-disk" />
